export default __webpack_public_path__ + "static/media/self_realization.d916ab9d.jpg";